export const REQUEST_PACKAGES = 'packages/REQUEST_PACKAGES';
export const SET_PACKAGES = 'packages/SET_PACKAGES';
